import { boundActionsFactory } from 'shared/hooks/useBoundActions';
import { trackPlaceOpen } from 'shared/store/analytics/actions/trackPlaceOpen';

export const usePlacementApplicationBoundActions = boundActionsFactory({
  trackPlaceOpen,
});
